import { render, staticRenderFns } from "./FormFinancial.vue?vue&type=template&id=4b8ec5a5"
import script from "./FormFinancial.vue?vue&type=script&lang=js"
export * from "./FormFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports